import { Expose } from "class-transformer";
import { Model } from "./model";

export class Announcement extends Model {
  @Expose() id: number;
  @Expose() message: string;
  @Expose() url: string;
  @Expose() urlName: string;
  @Expose() isForCustomer: boolean;
  @Expose() isForAdmin: boolean;
  @Expose() createdAt: number;
  @Expose() expiryDate: Date;
}
